module.exports = __webpack_public_path__ + "static/media/salford.8ee7f632.jpg";